export default __webpack_public_path__ + "static/media/ISMO CLASS-5 EXAM PATTERN 2026-27.c7caeebe.pdf";